import React, { useEffect, useRef, useState } from "react";
import CustomModal from "./CustomModal";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { TOAST_ERROR } from "../utils/common.service";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const FileModal = ({ isOpen, onClose, fileUrl }) => {
    const [iframeUrl, setIframeUrl] = useState("");
    const [numPages, setNumPages] = useState(null);
    const [containerWidth, setContainerWidth] = useState(600);
    const containerRef = useRef(null);

    const getFileType = (url) => {
        const extension = url.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) return 'image';
        if (['mp4', 'webm', 'ogg'].includes(extension)) return 'video';
        if (['pdf'].includes(extension)) return 'pdf';
        if (['txt'].includes(extension)) return 'text';
        return 'other';
    };

    const fileType = getFileType(fileUrl);

    useEffect(() => {
        if ((fileType === "text" || fileType === "other") && fileUrl && isOpen) {
            setIframeUrl(null);
            const timeout = setTimeout(() => {
                const url = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
                setIframeUrl(url);
            }, 100);
            return () => clearTimeout(timeout);
        }
    }, [fileUrl, fileType, isOpen]);

    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
        }
    }, [isOpen]);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function onError(error) {
        console.error('Error loading document:----------------------   ', error);
        TOAST_ERROR("Unable to display the PDF at the moment. Please try again later.");
    }

    return (
        <>
            <CustomModal title={"Preview"} isOpen={isOpen} handleClose={onClose}>
                {fileType === 'image' && <img src={fileUrl} alt="Preview" />}

                {fileType === 'video' && (
                    <video controls autoPlay className="h-100 w-100">
                        <source src={fileUrl} />
                        Your browser does not support the video tag.
                    </video>
                )}

                {fileType === "pdf" && (
                    <div ref={containerRef} style={{ overflowY: 'auto', maxHeight: '70vh' }}>
                        <Document
                            file={fileUrl}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onError={onError}
                        >
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    width={containerWidth - 32}
                                    className="my-2"
                                />
                            ))}
                        </Document>
                    </div>
                )}

                {(fileType === "text" || fileType === "other") && iframeUrl && (
                    <iframe
                        key={iframeUrl}
                        src={iframeUrl}
                        title="Document"
                        className="w-100"
                        style={{ height: "70vh", border: "none" }}
                    />
                )}
            </CustomModal>
        </>
    );
};

export default FileModal;
